<div class="modal-content">
    <div class="modal-header">
      <h1 class="modal-title pull-left" id="my-modal-title">{{'PRIMARY_CARE_GIVERS' | globalTranslate}}</h1>
      <button type="button" class="btn-close pull-right" [attr.aria-label]="'CLOSE' | globalTranslate" (click)="onCancel()">
        <img src="../../assets/images/⚛️ icons-close-circle-outline.svg" alt="close-icon"/>
      </button>
    </div>
    <div class="modal-body">
      <h2  class="section-header">
        {{'PRIMARY_CARE_GIVER_INFO' | globalTranslate}}
      </h2>
      <hr/>
      <p>
        {{'PRIMARY_CARE_GIVERS_STATIC_TEXT1' | globalTranslate}}
      </p>
    </div>
  </div>
